import React, { useEffect, useRef, useState, useLayoutEffect  } from "react";
import OwlCarousel from "react-owl-carousel3"; 
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { Modal, Row, Col } from "react-bootstrap";
import "./Home.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { validateForm } from "../../Utils/validate";
import { gettoastsuccess, gettoastwarning } from "../../Utils/Common";

const Home = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [errors, setErrors] = useState({});

  const [location, setLocation]=useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  // const [showImage, setShowImage] = useState(false);

	const [titlehed, setTitlehed] = useState('Your Friend, My Friend');

  const [inputs,setInputs] = useState({title:'',sub_heading:'',image:'',description:'',button_1_text:'',button_1_link:'',button_2_text:'',button_2_link:''});

  const [inputsn,setInputsn] = useState({first_name:'',last_name:'',email:'',mobile_number:'',location:'',gender:'',birth_year:'',agree:false,location_name:''});

  const [videoLoaded, setVideoLoaded] = useState(false);

  // const handleVideoError = () => {
  //   setShowImage(true);
  // };

	const [loading,setLoading] = useState(true);
	const [category, setCategory] = useState([]);
	
  const carouselRef = useRef(null);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  //
  const containerRefs = useRef([]);
  useLayoutEffect(() => {
    containerRefs.current.forEach((container) => {
      if (!container) return;
  
      const handleMove = (e) => {
        // const arrow = container.querySelector(".carousel-arrow");
        // const rect = container.getBoundingClientRect();
        // const x = e.clientX - rect.left;
        // const y = e.clientY - rect.top;
        // if (arrow) {
        //   arrow.style.transform = `translate(${x}px, ${y}px)`;
        //   arrow.style.opacity = 1;
        // }
      };
  
      const handleLeave = () => {
        const arrow = container.querySelector(".carousel-arrow");
        if (arrow) {
          arrow.style.opacity = 0;
        }
      };
  
      container.addEventListener("mousemove", handleMove);
      container.addEventListener("mouseleave", handleLeave);
  
      // Cleanup
      return () => {
        container.removeEventListener("mousemove", handleMove);
        container.removeEventListener("mouseleave", handleLeave);
      };
    });
  }, [category]); // Only run when category changes
  //
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
    document.title = `Your Friend, My Friend | Singles Events Ireland `;
    document.getElementById('bodywrap').className='home';

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", "Your Friend, My Friend hosts Ireland’s top in-person dating events — from Speed Dating and large singles parties to singles run clubs and weekend getaways.");
    } 


	 /* Start get home data */
let formData = new FormData(); 
		formData.append('type', 'home');
		API.post('get_category', formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
			   setCategory(response.data.data);
			}                  
		}).catch(error => {
			 
		});  
	 /* End get home data */
	 
	 /* Start get home data */
		API.get('get_home_page')
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
			   setTitlehed(response.data.data.title);
			}                  
		}).catch(error => {
			 
		});  
	 /* End get home data */


    /* Start get location data */
    API.get('get_location')
      .then(response => {
      if(response.data.status === false){
        
      }else{
         setLocation(response.data.data);
      }                  
    }).catch(error => {
       
    });  
   /* End get location data */

  /* Start get promotional */
    API.post('promotional')
      .then(response => {
        setLoading(false);
      if(response.data.status === false){
        
      }else{
         setInputs({
            title:response.data.data.title,
            sub_heading:response.data.data.sub_heading,
            image:response.data.data.image,
            description:response.data.data.description,
            button_1_text:response.data.data.button_1_text,
            button_1_link:response.data.data.button_1_link,
            button_2_text:response.data.data.button_2_text,
            button_2_link:response.data.data.button_2_link
        });
   if (response.data?.data) {
        if(response.data.data.status===1)
        {
          const isShown = sessionStorage.getItem("modalShown");
          if (!isShown) {
               setShow(true);
               sessionStorage.setItem("modalShown", "true");
              }
          }else{
            if(response.data.data.newsletter_status===1){
              setShowHear(true);
            }
        }
         
      }  
      }                  
    }).catch(error => {
       
    });  
   /* End get promotional */


   /*const isShown = sessionStorage.getItem("modalShown");
 
    if (!isShown) {
      // delay 2 seconds
      const timer = setTimeout(() => {
        setShow(true);
        sessionStorage.setItem("modalShown", "true"); // set flag
      }, 2000);
 
      return () => clearTimeout(timer);
    }*/

   const handleMouseMove = (e) => {
    const container = containerRef.current;
    const button = buttonRef.current;

    if (container && button) {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      button.style.left = `${x}px`;
      button.style.top = `${y}px`;
    }
  };

  const container = containerRef.current;
  container?.addEventListener("mousemove", handleMouseMove);

  return () => {
    container?.removeEventListener("mousemove", handleMouseMove);
  };
  
    
  },[]);  

   const handleInputChange = (event) => {
    const { name, value } = event.target;
    

    // Mobile: only + and numbers
    if (name === "mobile_number") {
      // allow only one + and only at start
      if (!/^\+?\d*$/.test(value)) {
        return;
      }
    }

    setInputsn(inputsn => ({ ...inputsn, [event.target.name]: event.target.value }));
  }
const handleInputChangeCustom = (field, value) => {
    setInputsn({ ...inputsn, [field]: value })
  }

const handleInputChangeLocation = (e) => {
  const selectedOption = e.target.options[e.target.selectedIndex];
  const locationName = selectedOption.getAttribute("data-name");

  setInputsn(prev => ({
    ...prev,
    location: e.target.value,   // id
    location_name: locationName,   // name
  }));
};

const handleSubmit = async (event) => {
    event.preventDefault();
    const fields = [
      { field: 'first_name', label: 'First Name', rules: 'required', value: inputsn.first_name },
      { field: 'last_name', label: 'Last Name', rules: 'required', value: inputsn.last_name },
      { field: 'email', label: 'Email Address', rules: 'required|valid_email', value: inputsn.email },
      { field: 'agree', label: 'Agreement', rules: 'required', value: inputsn.agree ? '1' : '' },
      { field: 'location', label: 'Location', rules: 'required', value: inputsn.location },
      { field: 'gender', label: 'Gender', rules: 'required', value: inputsn.gender },
      { field: 'birth_year', label: 'Birth Year', rules: 'required', value: inputsn.birth_year },
    ];
    
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);

    } else {
      setErrors({});
      setLoading(true);
      try {
          let formData = new FormData(); 
            formData.append(`location`, inputsn.location);
            formData.append(`gender`, inputsn.gender);
            formData.append(`birth_year`, inputsn.birth_year);
            formData.append(`first_name`, inputsn.first_name);
            formData.append(`last_name`, inputsn.last_name);
            formData.append(`mobile_number`, inputsn.mobile_number);
            formData.append(`email`, inputsn.email);
            formData.append(`location_name`, inputsn.location_name);
            API.post('newsletter', formData)
                .then(response => {
                if(response.data.status === false){
                    gettoastwarning(response.data.message,'');
                    setLoading(false); 
                  }else{
                    setLoading(false); 
                    gettoastsuccess(response.data.message,'');
                    setInputsn({first_name:'',last_name:'',email:'',mobile_number:'',location:'',gender:'',birth_year:'',agree:false,location_name:''});
                    setIsDetailsModalOpen(false);
                  }                  
              }).catch(error => {
                   setLoading(false);
                    gettoastwarning('Something went wrong. Please try again later.','');
              });
        } catch (e) {
          setLoading(false);
          gettoastwarning(e.message);
        }
    }
  }



  const [showhear, setShowHear] = useState(false);

  const handleCloseHear = () => setShowHear(false);



  return (
    <>
      <Header />
      <div className="hello-world d-flex justify-content-center align-items-center" ref={containerRef}>
          {/* Fallback Image */}
          {!videoLoaded && (
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/image-1.jpg'}
              alt="Fallback"
              className="img-fluid position-absolute object-fit-cover w-100 h-100"
            />
          )}

          {/* Desktop Video */}
          <video
            autoPlay
            muted
            loop
            playsInline
            className="background-video"
            onLoadedData={() => setVideoLoaded(true)} 
            onError={() => setVideoLoaded(false)} 
          >
            <source
              src={process.env.REACT_APP_BASE_URL + "assests/images/homee-video.mp4"}
              type="video/mp4"
            />
            <p>Your browser does not support the video tag.</p>
          </video>
        <div className="hero-content text-center">
          <h1 className="hero-title">
		  {titlehed}
          </h1>
          <div className="res-a">
            <Link
              to="/upcoming-events"
              ref={buttonRef}
              className="hero-button text-decoration-none d-flex flex-column align-items-center d-none d-md-block"
              style={{ cursor: "default"}}
            >
              BROWSE EVENTS{" "}
              <div className="div">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/bro-arrow.svg'}
                  alt="arrow"
                  className="img-fluid"
                />
              </div>
            </Link>
            <Link
              to="/upcoming-events"
              className="hero-buttonx text-decoration-none d-flex flex-column align-items-center d-block d-md-none"
            >
              BROWSE EVENTS{" "}
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid events">
        <div className="row d-flex">
          <div className="col-md-4 order-1 order-md-1 d-flex flex-column flex-grow-1">
            <div className="tired">
              <h2>YFMF</h2>
              <h4>Tired of swiping, or just not meeting the right people?</h4>
            </div>
            <div className="tired-2 mt-auto">
              <p>
                Your Friend, My Friend (YFMF) is Ireland’s leading singles
                events company, helping like-minded singles connect in real life
                through Speed Dating, Singles Nights, Weekend Getaways, Singles
                Run Clubs and more.
              </p>
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                Browse events
              </Link>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center order-2 order-md-2 flex-grow-1 toktok">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/home-223.jpg'}
              alt="TikTok"
              className="img-fluid"
            />
          </div>
          <div className="col-md-4 d-flex align-items-end flex-grow-1 order-3 order-md-3">
            <div className="uk">
              <p className="mb-3">
                Step away from the apps and meet genuine people at our in-person
                singles events across Ireland—with exciting expansions coming
                soon to the UK!
              </p>
              <p>
                Whether you're looking for fast-paced connections at Speed
                Dating, a social night out with Singles Nights, or a fun and
                active way to meet people with our Singles Run Club, YFMF is
                here to help you find real connections, face-to-face.
              </p>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center d-md-none order-4">
            <Link to="/upcoming-events" className="brow-bu text-decoration-none">
              Browse Events
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid new-sec-last d-none">
          <div className="get-list-content">
            <div className="left">
              <h2>Get on the list.</h2>
              <p>
                Be first to hear about upcoming singles events,
              </p>
              <p>
                new locations and what we're planning next.
              </p>
            </div>

            <button className="cta-btn" onClick={() => setIsDetailsModalOpen(true)}>
              KEEP ME IN THE LOOP
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'} alt="arrow" className="arrow" />
            </button>
          </div>
      </div>

      <Modal
        show={isDetailsModalOpen}
        onHide={() => setIsDetailsModalOpen(false)}
        centered
        className="get-list-modal new"
        size="lg"
      >
        <Modal.Body>
          <div className="popup-card">
            <div className="modal-close-btn" onClick={() => setIsDetailsModalOpen(false)}>
              x
            </div>
            <h3>A few details...</h3>
            <p className="subtitle">
              This information will help us recommend events that will suit you best.
            </p>

            <form method="post" onSubmit={handleSubmit} encType="multipart/form-data" >
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="input-wrap">
                    <input type="text" className="form-control custom-input" placeholder="First name"
                      name="first_name"
                      value={inputsn.first_name}
                      onChange={handleInputChange}
                     />
                    <span className="input-dot" />
                  </div>
                  {errors.first_name && (
                    <p className="text-danger error-text">{errors.first_name}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="input-wrap">
                    <input type="text" className="form-control custom-input" placeholder="Last name" 
                      name="last_name"
                      value={inputsn.last_name}
                      onChange={handleInputChange}
                    />
                    <span className="input-dot" />
                  </div>
                  {errors.last_name && (
                    <p className="text-danger error-text">{errors.last_name}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="input-wrap">
                    <input type="text" className="form-control custom-input" placeholder="Email" 
                      name="email"
                      value={inputsn.email}
                      onChange={handleInputChange}
                    />
                    <span className="input-dot" />
                  </div>
                  {errors.email && (
                    <p className="text-danger error-text">{errors.email}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="input-wrap">
                    <input type="text" className="form-control custom-input" placeholder="Mobile Number" 
                      name="mobile_number"
                      value={inputsn.mobile_number}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.mobile_number && (
                    <p className="text-danger error-text">{errors.mobile_number}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="input-wrap select-wrap">
                    <select className="form-control custom-input" name="location" value={inputsn.location} onChange={handleInputChangeLocation}>
                      <option value="">Location</option>
                      {location.map((val, i) => (
                        <option value={val.id} data-name={val.name}>{val.name}</option>
                        ))}
                    </select>
                  </div>
                  {errors.location && (
                    <p className="text-danger error-text">{errors.location}</p>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="row g-3">
                    <div className="col-lg-6 col-md-12 col-6">
                      <div className="input-wrap select-wrap">
                        <select className="form-control custom-input new" name="gender" value={inputsn.gender} onChange={handleInputChange}>
                          <option value="">Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Non-binary">Non-binary</option>
                        </select>
                      </div>
                      {errors.gender && (
                        <p className="text-danger error-text">{errors.gender}</p>
                      )}
                    </div>

                    <div className="col-6 jode">
                      <div className="input-wrap select-wrap">
                      <select name="birth_year" id="birth_year" className="form-control custom-input new" value={inputsn.birth_year} onChange={handleInputChange}>
                          <option value="">Birth Year </option>
                          {Array.from(
                            { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                            (_, i) => 1940 + i
                          ).map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                      </select>
                    </div>
                      {errors.birth_year && (
                        <p className="text-danger error-text">{errors.birth_year}</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-6 alag">
                  <div className="input-wrap select-wrap">
                  <select name="birth_year" id="birth_year" className="form-control custom-input" value={inputsn.birth_year} onChange={handleInputChange}>
                          <option value="">Birth Year </option>
                          {Array.from(
                            { length: (new Date().getFullYear() - 19) - 1940 + 1 },
                            (_, i) => 1940 + i
                          ).map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                      </select>
                    </div>
                  {errors.birth_year && (
                    <p className="text-danger error-text">{errors.birth_year}</p>
                  )}
                </div>
              </div>

              <div className="mandatory">
                <span className="mandatory-dot"></span>
                Indicates mandatory fields
              </div>

              <div className="bottom-row">
                <div className="d-flex flex-column">
                <label className="checkbox">
                  <input type="checkbox" name="agree"
                    value={inputsn.agree ? '1' : ''}
                    checked={inputsn.agree}
                    onChange={(event) => handleInputChangeCustom('agree', event.target.checked)} />
                  <span className="checkmark" />
                  I agree to receive emails about YFMF events and accept the Privacy Policy.
                </label>
                {errors.agree && (
                  <p className="text-danger error-text">{errors.agree}</p>
                )}
                </div>
                <button className="cta-btn text-nowrap" type="submit">
                  KEEP ME IN THE LOOP
                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'} alt="arrow" className="arrow" />
                </button>

              </div>
              
            </form>
          </div>
        </Modal.Body>
      </Modal>

      <div className="container-fluid eventss">
        <div className="row g-3 align-items-stretch">
          <div className="col-md-4 img-col d-flex fiou">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/home-3.png'}
              alt="Event"
              className="img-fluid single"
            />
          </div>

          <div className="col-md-4 img-cols d-flex">
            <div className="testimonial-box">
              <div className="tes-1 flex-grow-1">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.svg'}
                  alt="Event"
                  className="img-fluid"
                />
                <p>
                  The singles night was so much fun with more opportunity to
                  mingle and spend as much time chatting to people as you
                  wanted. It was at the singles night I met a very lovely man
                  who I have been happily dating for 4 weeks now.
                </p>
              </div>
              <div className="tes-2">
                <Link to="/about" className="btn text-decoration-none">
                  ABOUT US
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 img-colss d-flex">
            <div className="row w-100 flex-grow-1">
              <div className="col-12 d-flex flex-column">
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <h3>150+</h3>
                  <p>events per year</p>
                </div>
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <h3>6</h3>
                  <p>counties across Ireland</p>
                </div>
                <div className="stats-box flex-grow-1 d-flex flex-column justify-content-center">
                  <h3>10,000+</h3>
                  <p>connections made</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid real-people">
        <h2>Meet real people, all single </h2>

        {/* Mobile View (Grid) */}
        <div className="d-block d-md-none">
          <div className="row g-3">
          {category.map((event, index) => {
              let link_url = '#'; // default link

                if (event.id === 10) {
                  link_url = '/relationship-coaching';
                }else if (event.id===3) {
                  link_url = '/singles-run-club';
                }else if (event.id===2) {
                  link_url = '/singles-events';
                }else if (event.id===9) {
                  link_url = '/singles-weekend-getaway';
                }else if (event.id===1) {
                  link_url = '/speed-dating';
                }else if (event.id===8) {
                  link_url = '/wine-tasting';
                }     
              return (
              <div key={index} className="col-lg-3 col-md-6">
                <Link to={link_url} className="event-link">
                  <div className="event-card">
                    <img
                      src={event.thumb_image}
                      alt={event.name}
                      className="img-fluid"
                    />
                    <p className="event-title">{event.name}</p>
                  </div>
                </Link>
              </div>
            );
          })}
          </div>
        </div>

        {/* Desktop View (Carousel) */}
		
        <div className="d-none d-md-block">
		{category.length >0 &&(
          <OwlCarousel
            ref={carouselRef}
            className="owl-theme"
            loop
            margin={20}
            nav={false}
            dots={false}
            stagePadding={385}
            autoplay={false}
            responsive={{
              0: { items: 1, stagePadding: 50 },
              576: { items: 1, stagePadding: 100 },
              768: { items: 2, stagePadding: 150 },
              1024: { items: 2, stagePadding: 200 },
              1200: { items: 2, stagePadding: 250 },
              1400: { items: 2, stagePadding: 385 },
            }}
          >
            {category.map((event, index) => {
              let link_url = '#'; // default link

                if (event.id === 10) {
                  link_url = '/relationship-coaching';
                }else if (event.id===3) {
                  link_url = '/singles-run-club';
                }else if (event.id===2) {
                  link_url = '/singles-events';
                }else if (event.id===9) {
                  link_url = '/singles-weekend-getaway';
                }else if (event.id===1) {
                  link_url = '/speed-dating';
                }else if (event.id===8) {
                  link_url = '/wine-tasting';
                }     
              return (
              <div className="item" key={index}>
                <div className="event-image-container"
                ref={(el) => (containerRefs.current[index] = el)}
                >
                  <button
                    className="carousel-arrow right"
                    onClick={() => carouselRef.current.next()}
                  >
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/hover-right.png'} alt="Next" />
                  </button>
                  <Link to={link_url} className="event-link">
                    <div className="event-card">
                      <img
                        src={event.thumb_image}
                        alt={event.name}
                        className="img-fluid"
                      />
                    </div>
                    <p className="event-title">{event.name} </p>
                  </Link>
                </div>
              </div>
            );
          })}
          </OwlCarousel>
		  )}
        </div>
		

        <div className="row">
          <div className="last-real">
            <p>
              From speed dating, singles parties and run clubs to weekend
              getaways.
            </p>
            <Link to="/upcoming-events" className="btn text-decoration-none">
              Browse Events
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid single-events">
        <div className="row d-flex align-items-strech g-4">
          {/* Image Section */}
          <div className="col-md-8 od-1 d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/single-event.png'}
              alt="Event Promo"
              className="img-fluid eve-img"
              style={{height: 520}}
            />
          </div>

          {/* Text Section */}
          <div className="col-md-4 od-2 d-flex">
            <div className="get-app text-center d-flex flex-column align-items-center justify-content-center w-100">
              <h2>GET THE APP</h2>
              <h3>Don’t miss a single event</h3>
              <p>
                Get early access to tickets, receive exclusive event
                notifications, and chat with attendees after the event to keep
                the conversation going.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <Link to="https://apps.apple.com/us/app/your-friend-my-friend/id6748553590" className="store-link" target='_blank'>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/app-store.svg'}
                    alt="Event Promo"
                    className="img-fluid store-image store-image-1"
                  />
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/app-store-hover.svg'}
                    alt="Event Promo Hover"
                    className="img-fluid store-image store-image-2"
                  />
                </Link>
                <Link to="https://play.google.com/store/apps/details?id=com.yourfriend.myfriend" className="store-link" target='_blank'>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/google-store.svg'}
                    alt="Event Promo"
                    className="img-fluid store-image store-image-1"
                  />
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/google-store-hover.svg'}
                    alt="Event Promo Hover"
                    className="img-fluid store-image store-image-2"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-flex align-items-strech g-4 mt-4">
          <div className="col-md-5 d-flex">
            <div className="match d-flex flex-column align-items-start justify-content-center w-100">
              <h2>Curated Singles Events</h2>
              <h3>Thoughtfully matched, exclusively designed</h3>
              <p>
                Introducing Curated Singles Events, an exclusive experience
                designed for singles looking for deeper, more meaningful
                connections. These intimate gatherings bring together
                like-minded individuals with shared interests and values, as
                well as those who have attended previous events and could be a
                great match.
              </p>
              <p>
                To join, simply complete the survey—this helps create the right
                mix of people for each event. Selected participants receive an
                exclusive invitation to an event designed for real connections.
              </p>
              <div className="te mt-2">
                <Link
                  className="btn text-decoration-none"
                  to="https://docs.google.com/forms/d/e/1FAIpQLScJyaU0gtVN-qeot1p8thiBI2b2YgyVJ03sTh-BoTyGGUcSSg/viewform"
                  target="_blank"
                  data-discover="true"
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-7 d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/matched.png'}
              alt="Event Promo"
              className="img-fluid eve-img"
            />
          </div>
        </div>
      </div>

      <div className="container-fluid asi-main">
        <Row>
            <Col>
              <h3>As seen in</h3>
            </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Row className="justify-content-center row-cols-2 row-cols-sm-3 row-cols-md-5">
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi1.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi2.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi3.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi4.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi5.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi6.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi7.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi8.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
              <Col className="d-flex align-items-center justify-content-center my-3">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/asi9.png'}
                  alt="The Irish Times"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Col>
        </Row>            
      </div>

      <div className="conainer-fluid accor">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Any questions?</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What types of singles events does Your Friend, My Friend
                  offer?
                </Accordion.Header>
                <Accordion.Body>
                  Your Friend, My Friend (YFMF) hosts a variety of in-person
                  singles events across Ireland. These include Speed Dating
                  nights, Singles Parties, Wine Tastings, Singles Run Clubs,
                  Curated Singles Events, and Relationship Coaching Workshops.
                  Whether you’re looking to meet likeminded singles in Dublin,
                  Galway, Cork, or Limerick, we have an event designed for you.{" "}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  How are YFMF events different from online dating or dating
                  apps?
                </Accordion.Header>
                <Accordion.Body>
                  Unlike dating apps, YFMF offers in-person singles events that
                  focus on genuine connections. Our events are designed to take
                  the pressure off and help you meet likeminded singles in a
                  relaxed, fun environment. There’s no swiping, endless hours of
                  texting, or catfishing—just real people looking to meet
                  face-to-face.{" "}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  How do I sign up for a singles event?
                </Accordion.Header>
                <Accordion.Body>
                  You can easily purchase a ticket for any of our singles events
                  directly through our website. However, the best way to hear
                  about new and upcoming events—and to secure your tickets
                  before they sell out—is through our Your Friend, My Friend
                  (YFMF) app. The app gives you early access to tickets,
                  exclusive event notifications, and the ability to chat with
                  other attendees after the event. Simply download the app,
                  browse upcoming events, and book your spot in just a few taps.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Where are YFMF events held?</Accordion.Header>
                <Accordion.Body>
                  We host singles events in Dublin, Galway, Cork, Limerick, and
                  London with new locations being added regularly. Whether
                  you’re looking for singles events near you or want to join one
                  of our Singles Run Clubs, our events are held at some of
                  Ireland’s top venues, creating the perfect atmosphere for
                  connection.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Are YFMF events successful in creating real connections and
                  relationships?
                </Accordion.Header>
                <Accordion.Body>
                  Yes. Many people who attend YFMF events go on to exchange
                  numbers, date, and even enter into long-term relationships. We
                  frequently hear success stories from attendees who’ve met
                  their partner at one of our events. Our focus is on quality
                  interactions, helping you connect with people who are
                  genuinely interested in meeting others.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  How should I prepare for a YFMF singles event?
                </Accordion.Header>
                <Accordion.Body>
                  Our events are casual and welcoming, so just bring yourself!
                  We recommend dressing smart casual—something you feel
                  confident and comfortable in. Be open to meeting new people,
                  and most importantly, enjoy yourself.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  Do people attend YFMF singles events alone?
                </Accordion.Header>
                <Accordion.Body>
                  Absolutely. Many people come to our events solo, and our team
                  makes sure everyone feels welcome. It’s a relaxed environment
                  designed for meeting new people, so you’ll never feel out of
                  place if you attend on your own.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  Is there an even split of males and females at YFMF events?
                </Accordion.Header>
                <Accordion.Body>
                  We do our best to ensure an even male-to-female ratio,
                  particularly at our Speed Dating events. While exact numbers
                  can vary at larger events like Singles Parties, we focus on
                  creating balanced groups to maximise your chances of meeting
                  likeminded singles.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  How many dates do you get at a Speed Dating event?
                </Accordion.Header>
                <Accordion.Body>
                  At our Speed Dating events, you typically meet between 16 and
                  20 singles, each for a five-minute date. It’s a fun,
                  fast-paced way to see if there’s a spark, and you’ll receive
                  your mutual matches via email the next day.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  Are there icebreakers or games at YFMF singles events?
                </Accordion.Header>
                <Accordion.Body>
                  Many of our singles events include fun icebreaker to help
                  spark conversations and encourage mingling. Our goal is to
                  create a relaxed, no-pressure environment where people can
                  connect naturally.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>
                  What is the Singles Run Club and how does it work?
                </Accordion.Header>
                <Accordion.Body>
                  The YFMF Singles Run Club is a casual 5K run (or walk) for
                  singles, followed by coffee, snacks, and mingling. It’s a
                  great way to meet active, likeminded singles without the
                  pressure of a formal dating event. We currently run these
                  events in Dublin and Galway, attracting 50 to 80 singles at
                  each event.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11">
                <Accordion.Header>
                  How can I stay updated on upcoming singles events?
                </Accordion.Header>
                <Accordion.Body>
                  The best way to stay informed about upcoming events is to
                  download the YFMF app. You’ll get early access to tickets and
                  notifications about new Speed Dating nights, Singles Parties,
                  and Run Clubs in your area. You can also follow us on
                  Instagram @yourfriendmyfriend.ie for regular updates.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="12">
                <Accordion.Header>
                  Are YFMF events suitable for people new to dating in Ireland
                  and UK?
                </Accordion.Header>
                <Accordion.Body>
                  Yes! Whether you’re new to the dating scene or looking to get
                  back out there, our singles events are designed to be
                  inclusive and welcoming. We host events for various age groups
                  and interests, making it easy to find an event that suits you.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="13">
                <Accordion.Header>
                  What is the age range for YFMF events?
                </Accordion.Header>
                <Accordion.Body>
                  We offer singles events for different age groups, typically
                  ranging from mid-20s to early 60s. Each event listing will
                  specify the intended age range, so you can book the one that’s
                  right for you.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="14" className="hololast">
                <Accordion.Header>
                  Can I suggest an event or location for YFMF to host?
                </Accordion.Header>
                <Accordion.Body>
                  We love hearing from our community! If there’s a type of
                  singles event you’d like to see or a location you think we
                  should bring YFMF to, feel free to contact us through our
                  website or social media.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>


      <Modal show={showhear} onHide={handleCloseHear} backdrop="static" size="lg" className="hear-modal" centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <p>JOIN THE MAILING LIST</p>
          <h3>Be first to hear about upcoming singles events.</h3>
          <h5>Our events sell out fast. Join our YFMF 'Friends with Benefits' list for new events and early access to tickets.</h5>
            <button className="hear-btn" onClick={() => {
                                        handleCloseHear();
                                        setIsDetailsModalOpen(true);
                                      }}>
              Join Now
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'} alt="arrow" className="arrow" />
            </button>          
        </Modal.Body>
      </Modal>


      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modal"
        contentClassName="custom-content"
        size="lg"
      >
         {/* Close button top-right */}
        <button className="custom-close" onClick={handleClose}>
          <span className="close-x">×</span>
          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/modu-close-sign.png"}
            alt="Popup"
            className="close-img"
          />
        </button>

        <Modal.Body className="p-0 holko">
          <Row className="g-0">
            <Col sm={5} md={5} className="">
              <img
                src={inputs.image}
                alt="Popup"
                className="w-100 h-100 object-fit-cover"
              />
            </Col>

            <Col sm={7} md={7} className="d-flex flex-column justify-content-center holko2">
              <h6 className="text-uppercase mb-2">{inputs.sub_heading}</h6>
              <h3>{inputs.title}</h3>
              <p>
                {inputs.description}
              </p>
              <div className="d-flex gap-2 omcha">
                {inputs.button_1_text ? (<Link to={inputs.button_1_link} className="duo-1 text-uppercase text-decoration-none">{inputs.button_1_text}</Link>) : null }
                {inputs.button_2_text ? (<Link to={inputs.button_2_link} className="duo-2 text-uppercase text-decoration-none">{inputs.button_2_text}</Link>) : null }
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>


	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
     
      <Appqr />
      <Footer />
    </>
  );
};

export default Home;
